export default __webpack_public_path__ + "static/bill-approved-f7526176074d6e62666123f01632259e.svg";